import { Component, HostBinding, Input } from '@angular/core';

import { BaseBadgeComponent } from '../base-badge/base-badge.component';

@Component({
  selector: 'ts-status-badge',
  templateUrl: './status-badge.component.html',
  imports: [BaseBadgeComponent]
})
export class StatusBadgeComponent {
  @HostBinding('class') classes: string = 'd-contents';
  @Input() status: string = '';
  @Input() status_display_name: string = '';
  @Input() class: string = '';

  variant(): string {
    switch (this.status.toLowerCase()) {
      case 'active':
        return 'success';
      case 'suspended':
        return 'danger';
      case 'inactive':
        return 'secondary';
      default:
        return 'info';
    }
  }
}
